
import { carritoApi } from "../../apis";
import { useCarritoItemsStore } from "../../stores/ops/carritoItems";
import Swal from "sweetalert2";



export const carritoOItemXID = async(id) => {
    try {
        const { data } = await carritoApi.get(`/xid/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const listadoCarritoXOp = async(id) => {
    try {
        const { data } = await carritoApi.get(`/carrito-op/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const agregarItemCarritoAdmin = async(body, itemID) => {
    try {
        if( itemID ){
            await carritoApi.put(`/${itemID}`, body);
            Swal.fire('Exitoso', 'Item Actualizado', 'success');
            return true;
        }else {
            await carritoApi.post(`/new`, body);
            Swal.fire('Exitoso', 'Item Agregado', 'success');
            return true;
        }
    } catch (error) {
        console.log(error)
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const listadoCarritoXUser = async(id) => {
    try {
        const { data } = await carritoApi.get(`/xuser/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}  



export const listadoTodosItemCarritos = async({ page, termino }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await carritoApi.get(`/todos/items`, { params });
        useCarritoItemsStore.getState().setTotalItems(data.total);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoItemsParaTrabajo = async({ page, termino }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        const { data } = await carritoApi.get(`/disponibles/trabajo`, { params });
        useCarritoItemsStore.getState().setTotalItems(data.total);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const editarValorItemCarrito = async(body) => {
    try {
        await carritoApi.put(`/editar/valor`, body);
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const modificarNombreCotizacion = async(body) => {
    try {
        await carritoApi.put(`/modificar/nombre`, body);
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const editarValoresDetalles = async(body) => {
    try {
        const formData = new FormData();
        if (body?.img && typeof body?.img !== 'string') {
            formData.append('images', body.img);
        }
        Object.entries(body).forEach(([key, value]) => {formData.append(key, value?.toString()); });
        const { data } = await carritoApi.put(`/update/detalles`, formData);
        Swal.fire('Exito', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const asignarColaborador = async(body) => {
    try {
        await carritoApi.post(`/asignar/colaborador`, body);
        Swal.fire('Exito', 'Items Asignados', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const marcarItemsComoCompletado = async(body) => {
    try {
        await carritoApi.post(`/completar/items`, body);
        Swal.fire('Exito', 'Items Completados', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const listadoMisItemsTrabajo = async({ page, termino }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await carritoApi.get(`/disponibles/xcolaborador`, { params });
        useCarritoItemsStore.getState().setTotalItems(data.total);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const entregarItemColaborador = async(id) => {
    try {
        await carritoApi.get(`/entregar/item/${id}`);
        Swal.fire('Exitoso', 'Item Terminado', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const eliminarItemCarrito = async(id) => {
    try {
        await carritoApi.delete(`/${id}`);
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}

